import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=c6c85b52&scoped=true"
import script from "./Email.vue?vue&type=script&lang=ts"
export * from "./Email.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c85b52",
  null
  
)

export default component.exports